import {Component, effect, OnInit, signal} from '@angular/core';
import {Field, form, validateStandardSchema} from '@angular/forms/signals';
import {z} from 'zod';
import {InputText} from 'primeng/inputtext';
import {AppBaseComponent} from '../../shared/components/app-base-component/app-base-component';
import {Select} from 'primeng/select';
import {JsonPipe} from '@angular/common';
import {SelectButton} from 'primeng/selectbutton';
import {ZodAutoValidateDirective} from '../../shared/decorators/auto-validate/auto-validate';
import {map} from 'rxjs';
import {PersonalInfo} from './personal-info/personal-info';
import {UploadImages} from './upload-images/upload-images';
import {UploadExtraImages} from './upload-extra-images/upload-extra-images';
import {Habits} from './habits/habits';
import {ResidencyData} from './residency-data/residency-data';
import {ProfileCompleted} from './profile-completed/profile-completed';
import {USER_UPDATED} from '../../event-disctionary';
import {VerifyPhone} from './verify-phone/verify-phone';

const isAdultByBirthYear = () =>
  z.number().superRefine((birthYear, ctx) => {
    const currentYear = new Date().getFullYear();
    const age = currentYear - birthYear;

    if (birthYear && age < 18) {
      ctx.addIssue({
        code: 'custom',
        message: 'You must be at least 18 years old',
        params: {minAge: 18},
      });
    }
  });
const userSchema = z.object({
  name: z.string(),
  sex: z.string().nullable(),
  birth_year: isAdultByBirthYear(),
  profile_for: z.string().nullable(),
  height: z.string().nullable(),
  weight: z.string().nullable(),
  drinking_habit: z.string().nullable(),
  smoking_habit: z.string().nullable(),
  caste: z.string().nullable(),
  religion: z.string().nullable(),
  education: z.string().nullable(),
  occupation: z.string().nullable(),
  income: z.string().nullable(),
  diet: z.string().nullable(),
  body_build: z.string().nullable(),
  complexion: z.string().nullable(),
})

@Component({
  selector: 'app-complete-profile-dialog',
  imports: [
    PersonalInfo,
    UploadImages,
    UploadExtraImages,
    Habits,
    ResidencyData,
    ProfileCompleted,
    VerifyPhone
  ],
  templateUrl: './complete-profile-dialog.html',
  styleUrl: './complete-profile-dialog.css',
})
export class CompleteProfileDialog extends AppBaseComponent {
  step = signal(1);

  constructor() {
    super();
    effect(() => {
      if (this.step() == 7) this.eventBus.cast(USER_UPDATED)
    })
  }
}
